module Meevo.Plugins.SaleProgram {
    class ProductsFilterController {
        static $inject = [
            "meevo.components.modal.ModalService", "$mdDialog", "context"
        ];

        private manufacturerId: string;
        private distributorId: string;
        private subCategoryId: string;
        private displayName: string;

        constructor(private modalService: Meevo.Components.Modal.IModalService, private $mdDialog, private context) {
            this.manufacturerId = context.manufacturerId;
            this.distributorId = context.distributorId;
            this.subCategoryId = context.subCategoryId;
            this.displayName = context.displayName;
        }

        clearFilter = (): void => {
            this.context.manufacturerId = null;
            this.context.distributorId = null;
            this.context.subCategoryId = null;
            this.context.displayName = null;
            this.closeModal();
        }

        applyFilter = (): void => {
            this.context.manufacturerId = this.manufacturerId;
            this.context.distributorId = this.distributorId;
            this.context.subCategoryId = this.subCategoryId;
            this.context.displayName = this.displayName;
            this.closeModal();
        }

        closeModal = (): void => {
            this.$mdDialog.cancel();
        }
    }

    angular.module("meevo.plugins.saleProgram")
        .controller("meevo.plugins.saleProgram.ProductsFilterController", ProductsFilterController);
}
